import { render, staticRenderFns } from "./file-full-image.vue?vue&type=template&id=40f1e1f0&scoped=true&lang=pug"
import script from "./file-full-image.vue?vue&type=script&lang=js"
export * from "./file-full-image.vue?vue&type=script&lang=js"
import style0 from "./file-full-image.vue?vue&type=style&index=0&id=40f1e1f0&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f1e1f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\G\\YT\\mes-project-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40f1e1f0')) {
      api.createRecord('40f1e1f0', component.options)
    } else {
      api.reload('40f1e1f0', component.options)
    }
    module.hot.accept("./file-full-image.vue?vue&type=template&id=40f1e1f0&scoped=true&lang=pug", function () {
      api.rerender('40f1e1f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wl-component-gallery/wl-upload/components/file-full-image.vue"
export default component.exports